import React, { useState, useEffect, useCallback } from "react";
import { message } from "antd";

import { downloadFile } from "../../../components/util";
import { WrappedFormHabilityType } from "./formHabilityType";
import { QmDimensionTable } from "../components/qmTable";
import { ColumnProps, PaginationConfig, SorterResult } from "antd/lib/table";
import { IHabilityType, IHabilityTypeListResponse } from "./types";
import { ITableFilter, ITableSort, QmKeyObject } from "../components/types";
import { Utilitaries } from "../../../business";
import { remove, select } from "../actions/dimensionsAndType";

const listName = "tipos_habilidades";
const REPORT_PARAMS = {
    accao: "lista",
    lista: listName,
    campos: "designacao:150:Tipo de habilidade;descricao:650:Descrição;",
    titulo: "Tipos de Habilidades",
};

export function HabilityType() {
    const [dataSource, setDataSource] = useState<IHabilityType[]>([]);
    const [loadingData, setLoadingData] = useState(true);
    const [showDeleteRecords, setShowDeleteRecords] = useState(false);
    const [filter, setFilter] = useState<ITableFilter>({
        pagination: {
            page: 1,
            perPage: 0,
        },
        filter: {},
    });

    const [editRow, setEditRow] = useState<IHabilityType | null>(null);
    const [showModalNew, setShowModalNew] = useState(false);

    /** get tipos habilidades from the server */
    const getHabilityType = useCallback(() => {
        setLoadingData(true);
        select({
            accao: "lista",
            lista: listName,
            pagina: 1,
            resultados_pagina: 0,
            mostra_lista_eliminados: showDeleteRecords,
        })
            .then((responses: IHabilityTypeListResponse) => {
                const list: IHabilityType[] = Utilitaries.toArray(responses.linha);
                const data = list.map((item) => {
                    return {
                        ...item,
                        designacao: typeof item.designacao === "object" ? "" : item.designacao,
                        descricao: typeof item.descricao === "object" ? "" : item.descricao,
                        versao: typeof item.versao === "object" ? "" : item.versao,
                    };
                });

                setDataSource(data);
                setLoadingData(false);
            })
            .catch(() => {
                message.error("Ocorreu um erro ao carregar os tipos de habilidades.");
            });
    }, [showDeleteRecords]);

    useEffect(() => {
        getHabilityType();
    }, [getHabilityType]);

    async function onExportList(type: "pdf" | "xls") {
        const params = {
            ...REPORT_PARAMS,
            filter,
            saida: type,
            downloadInBrowser: true,
        };
        await downloadFile("gerelistas.php", params);
    }

    function toggleShowDelete(value: boolean) {
        setShowDeleteRecords(value);
    }

    function handleNew() {
        setShowModalNew(true);
    }

    function handleCloseNew(reload?: boolean) {
        if (reload) {
            getHabilityType();
        }
        setShowModalNew(false);
    }

    function handleEdit(row: IHabilityType) {
        setEditRow(row);
    }

    function handleCloseEdit(reload?: boolean) {
        if (reload) {
            getHabilityType();
        }
        setEditRow(null);
    }

    function deleteRow(id: string) {
        remove({
            accao: "eliminar",
            lista: listName,
            chave1: id,
        }).then((sucess) => {
            if (sucess) {
                message.success("Linha eliminada com sucesso");
                getHabilityType();
            } else {
                message.error("Ocorreu um erro");
            }
        });
    }

    /** for search results in table */

    function handleTableChange(
        _: PaginationConfig,
        filters: Partial<Record<keyof IHabilityType, string[]>>,
        sorter: SorterResult<IHabilityType>
    ) {
        const objFilter: QmKeyObject = {};

        if (filters) {
            Object.entries(filters).forEach(([key, val]) => {
                if (val && val[0]) objFilter[key] = val[0];
            });
        }

        let sortObj: ITableSort | null = null;
        if (sorter.columnKey && sorter.order) {
            sortObj = {
                sorterBy: sorter.columnKey,
                sorterOrder: sorter.order,
            };
        }

        setFilter((state) => ({
            ...state,
            pagination: {
                ...state.pagination,
                page: 1,
            },
            filter: objFilter,
            sorter: sortObj ?? undefined,
        }));
    }

    const columns: ColumnProps<IHabilityType>[] = [
        {
            title: "Designação",
            dataIndex: "designacao",
            width: "30%",
            ...QmDimensionTable.columnsSearch("designacao"),
        },
        {
            title: "Descrição",
            dataIndex: "descricao",
            width: "50%",
            ...QmDimensionTable.columnsSearch("descricao"),
        },
        {
            title: "Ações",
            dataIndex: "actions",
            width: "20%",
            render: (_, record) =>
                record._eliminado_ === "t" ? (
                    <QmDimensionTable.actions
                        deleteRow={() => deleteRow(record.id_tipo_habilidade)}
                        handleEdit={() => handleEdit(record)}
                    />
                ) : null,
        },
    ];
    return (
        <>
            <QmDimensionTable.list
                rowKey={(record) => record.id_tipo_habilidade}
                loading={loadingData}
                columns={columns}
                dataSource={dataSource}
                exportList={onExportList}
                toogleShowDeletedRecords={toggleShowDelete}
                handleNew={handleNew}
                onChange={handleTableChange}
            />

            {showModalNew && <WrappedFormHabilityType onClose={handleCloseNew} />}
            {editRow && <WrappedFormHabilityType record={editRow} onClose={handleCloseEdit} />}
        </>
    );
}
